import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

type StylesType = {
  windowHeight?: string
}

const useStyles = makeStyles<Theme, StylesType>(theme => ({
  modalClose: {
    top: '24px',
    right: '24px'
  },

  mobileChildren: {
    height: ({ windowHeight }) => windowHeight,
    maxHeight: '100%'
  },

  root: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden auto',
    paddingTop: '6px'
  },

  mobileRoot: {
    marginTop: '0',
    paddingTop: '0'
  },

  mobileTitle: {
    display: 'flex',
    alignItems: 'center',
    margin: '16px 0 22px 0',

    '& > span': {
      fontSize: theme.size.lg,
      color: '#1F1F1F'
    }
  },

  mobileBackArrow: {
    marginRight: '16px',
    cursor: 'pointer'
  },

  deleteMessage: {
    marginBottom: '16px'
  },

  messageHolder: {
    border: '1px solid rgba(0, 0, 0, 0.15)',
    borderRadius: '8px',
    boxSizing: 'border-box',
    boxShadow: '1px 1px 1px 0px rgba(0, 0, 0, 0.15)',
    paddingTop: '4px'
  },

  buttonArea: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: '96px',
    paddingTop: 12,
    '& > :first-child': {
      marginRight: '16px'
    }
  },

  buttonAreaMobile: {
    justifyContent: 'center',
    bottom: '68px',
    left: '0',
    right: '0',
    margin: '0',
    height: 'auto',
    padding: '12px 24px',

    '& button': {
      flex: '1',
      maxWidth: '200px'
    }
  },

  button: {
    height: '48px'
  }
}))

export default useStyles
